import { ActionTypesDocuments } from './constants';
import { DocumentDirectory, DocumentsInitialStateType } from './types';

// The initial state of the App
const initialState: DocumentsInitialStateType = {
  selectedKeyPath: '',
  directoriesData: [] as DocumentDirectory[],
  isDocumentsDownloadLoading: false,
  isDocumentDeleteLoading: false,
  isDocumentLoading: false,
  refreshCache: false,
  isDocumentUploadLoading: false,
};

function documentsReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypesDocuments.SET_SELECTED_FOLDER_KEY_PATH:
      return {
        ...state,
        selectedKeyPath: action.keyPath,
      };
    case ActionTypesDocuments.SET_DOCUMENT_DIRECTORY_LIST:
      return {
        ...state,
        directoriesData: action.gridData,
      };
    case ActionTypesDocuments.TOGGLE_IS_DOCUMENT_DOWNLOAD_LOADING:
      return {
        ...state,
        isDocumentsDownloadLoading: action.isLoading,
      };
    case ActionTypesDocuments.TOGGLE_IS_DOCUMENT_DELETE_LOADING:
      return {
        ...state,
        isDocumentDeleteLoading: action.isLoading,
      };
    case ActionTypesDocuments.TOGGLE_IS_DOCUMENT_UPLOAD_LOADING:
      return {
        ...state,
        isDocumentUploadLoading: action.isLoading,
      };
    case ActionTypesDocuments.TOGGLE_IS_DOCUMENT_LOADING:
      return {
        ...state,
        isDocumentLoading: action.isLoading,
      };
    case ActionTypesDocuments.TOGGLE_REFRESH_CACHE:
      return {
        ...state,
        refreshCache: action.refreshCache,
      };
    default:
      return state;
  }
}

export default documentsReducer;
